import {
  postData,
  putData,
  getData,
  deleteData
} from './request'


// 修改文件权限与有效期
export function updateShare(paload, cb) {
  return putData(`/api/v3/groups/${paload.groupid}/files/${paload.fileid}/shareinfo`, paload, {}, cb)
}

// 取消分享
export function cancelShare(paload,cb){
    return postData(`/api/v3/groups/${paload.groupid}/files/${paload.fileid}/actions/unshare`,paload,{},cb)
}

// 获取权限联系人
export function getMembers(paload, cb) {
  return getData(`/api/v3/groups/${paload.groupid}/files/${paload.fileid}/invitees`, {}, cb)
}
// 修改联系人权限
export function  switchPermission(paload,cb) {
  return putData(`/api/v3/groups/${paload.groupid}/files/${paload.fileid}/invitees/${paload.invitee}`, paload, {}, cb)
}
// 移除文件权限人
export function removeMember(paload, cb) {
  return deleteData(`/api/v3/groups/${paload.groupid}/files/${paload.fileid}/invitees/${paload.invitee}`, paload, {}, cb)
}
// 根据sid获取权限
export function getPermission(code, cb) {
  return getData(`/api/sharedocs/${code}/shareinfo`, {}, cb)
}


// WEBPACK FOOTER //
// ./src/store/service/share.js